

export const myRoutes = {
    // pages

    Presentation: { path: "/" },
    DashboardOperator: { path: "/dashboard/dashboardoperator.js" },
    DashboardOperatorX: { path: "/dashboard/dashboardoperatorx" },
    DashboardOverview: { path: "/dashboard/dashboardoverview.js" },
    DashboardTraffic: { path: "/dashboard/dashboardtraffic-and-engagement" }, 
    DashboardProductAnalysis: { path: "/dashboard/dashboardproduct-analysis" },
    DashboardFicusPlayground: { path: "/dashboard/dashboardficusplayground" },

    ContactsHubSpot: { path: "/contactshubspot.js" },
    Students: { path: "/students.js" },
		FicusSignIn: { path: "/access/signin.js" },
		FicusAdminSignIn: { path: "/access/ficusadminsignin.js" },		
		FicusAdminHome: { path: "/access/ficusadminhome.js" },		
    ResetPassword: { path: "/access/reset-password" },
    ChangePassword: { path: "/access/changepassword/*" },
		UserStatus: { path: "/access/userstatus.js" },
    MyAccount: { path: "/myaccount" },
    FAQ: { path: "/faq" },
    Profile: { path: "/profile" },
    Contact: { path: "/contact" },
    Share: { path: "/share" },
    Inquiry: { path: "/inquiry/:id" },
    LocationURL: { path: "/locationurl/:id" },
    StatusListing: { path: "/admin/statuslisting/:id" },
    DocsAbout: { path: "/documentation/about" },
    Loading: { path: "/access/loading" },

    Kanban: { path: "/kanban" },
    Messages: { path: "/messages" },
    SingleMessage: { path: "/message" },
    SingleNotification: { path: "/message" },
    Users: { path: "/users" },
    Transactions: { path: "/transactions" },
    Tasks: { path: "/tasks" },
    Notifications: { path: "/notifications" },
    Settings: { path: "/settings" },
    Calendar: { path: "/calendar" },
    Map: { path: "/map" },
    Datatables: { path: "/tables/datatables" },
    BootstrapTables: { path: "/tables/bootstrap-tables" },
    MIQCountries: { path: "/tables/test-api-tables" },
    HubspotContacts: { path: "/tables/test-api-tables" },
    Pricing: { path: "/examples/pricing" },
    Billing: { path: "/examples/billing" },
    Invoice: { path: "/examples/invoice" },
    Signin: { path: "/examples/sign-in" },
    Signup: { path: "/examples/sign-up" },
    Lock: { path: "/examples/lock" },
    NotFound: { path: "/examples/404" },
    ServerError: { path: "/examples/500" },

    // docs
    DocsOverview: { path: "/documentation/overview" },
    DocsDownload: { path: "/documentation/download" },
    DocsQuickStart: { path: "/documentation/quick-start" },
    DocsLicense: { path: "/documentation/license" },
    DocsFolderStructure: { path: "/documentation/folder-structure" },
    DocsBuild: { path: "/documentation/build-tools" },
    DocsChangelog: { path: "/documentation/changelog" },

    // plugins
    PluginSignatureCanvas: { path: "/plugins/signaturecanvas" },
    PluginCharts: { path: "/plugins/charts" },
    PluginCalendar: { path: "/plugins/calendar" },
    PluginDatatable: { path: "/plugins/datatable" },
    PluginMap: { path: "/plugins/map" },
    PluginDropzone: { path: "/plugins/dropzone" },
    PluginSweetAlert: { path: "/plugins/sweet-alert" },

    // components
    Accordions: { path: "/components/accordions" },
    Alerts: { path: "/components/alerts" },
    Badges: { path: "/components/badges" },
    Widgets: { path: "/widgets" },
    Breadcrumbs: { path: "/components/breadcrumbs" },
    Buttons: { path: "/components/buttons" },
    Forms: { path: "/components/forms" },
    Modals: { path: "/components/modals" },
    Navs: { path: "/components/navs" },
    Navbars: { path: "/components/navbars" },
    Pagination: { path: "/components/pagination" },
    Popovers: { path: "/components/popovers" },
    Progress: { path: "/components/progress" },
    Tables: { path: "/components/tables" },
    Tabs: { path: "/components/tabs" },
    Tooltips: { path: "/components/tooltips" },
    Toasts: { path: "/components/toasts" },
    WidgetsComponent: { path: "/components/widgets" }
};